import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import { useNavigate, Navigate} from "react-router";

import AuthService from "../services/auth.service";
import UserService from "../services/user.service";

import Template from "./common/template/Template";
import Loading from "./common/template/Loading"

import { useAuth } from "../context/AuthContext";


export default function Home () {

    const { user } = useAuth();

  
  const navigate = useNavigate();

  //const user = AuthService.getCurrentUser();
  
  const wrapperClass = `w-full h-full p-4 mt-12 mb-4 mx-auto  rounded-lg md:rounded-b-none  shadow-md bg-white`;

  let usernameClassName = ``;
 


  //if (!user ){
  //   localStorage.removeItem("cs_uxsurvey_session");
  //}

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const [content, setContent] = useState(false);//the whole data object returned by the api call
  const [countPending, setCountPending] = useState(false);//the whole data object returned by the api call
  const [countCompleted, setCountCompleted] = useState(false);//the whole data object returned by the api call

  useEffect(() => {

    if(!user){
      navigate("/login");
    }

    if (user) {
      setLoading(true);
      UserService.getTasks(user)
        .then((response) => {
          console.log(response)
          setContent(response.data);
          
          setCountPending(parseInt(response.data?.tasks_count_pending));
          setCountCompleted(parseInt(response.data?.tasks_count_completed));
          setMessage(response.data?.message);
        })
        .catch((error) => {
          const _content =
            (error?.response && error?.response.data) ||
            error?.message ||
            error?.toString();
          setContent(_content);
          setCountPending(false);
          setCountCompleted(false);
          
        })
        .finally(() => setLoading(false));
    }

  }, []);
      
  
    return (
    

      <Template >

        <div className={` `+wrapperClass}>
          
          
          {user ? (
            <>
              {!loading ? (
                <>
                   <h1 className="text-zinc-600 text-2xl md:text-3xl lg:text-4xl">Hola&nbsp; 
                      <Link to="/profile" className="underline hover:no-underline text-sky-400 font-light">
                        <span className={`${usernameClassName} `}>{user.fullname}</span>
                      </Link><sup className="text-[8px]">{`[${user.uId}]`}</sup>
                    </h1>
                    <p className="text-zinc-600 text-sm font-light">
                        Tienes <Link to="/mytasks" className="font-semibold" >{countPending}</Link> tareas asignadas pendientes.<br/>
                        Has completado <Link to="/mytasks" className="font-semibold">{countCompleted}</Link> tareas asignadas este mes.
                    </p>
                </>               
              ) : (
                  <Loading />
              )
              }           
              
            </> 
              ) : (
                <Navigate to="/login" replace={true}  state={{ from: "/home" }}/>
              )
          
          }
      
        </div>
      
      
      </Template>
    
    
      
    );
  
     

};


